var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00006 12.6667L14.0001 12.6667C14.1216 12.6663 14.2406 12.6328 14.3445 12.5698C14.4484 12.5067 14.5331 12.4166 14.5895 12.309C14.646 12.2014 14.672 12.0804 14.6648 11.9591C14.6576 11.8379 14.6175 11.7208 14.5487 11.6207L8.54872 2.95401C8.30006 2.59467 7.70139 2.59467 7.45206 2.95401L1.45206 11.6207C1.38261 11.7206 1.34188 11.8377 1.3343 11.9592C1.32672 12.0807 1.35258 12.2019 1.40907 12.3097C1.46555 12.4176 1.55051 12.5078 1.6547 12.5708C1.75889 12.6337 1.87834 12.6669 2.00006 12.6667Z",
    fill: "#FC6603"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropup);
export default __webpack_public_path__ + "static/media/dropup.0ab88d99effbf26c23126194e8ae8492.svg";
export { ForwardRef as ReactComponent };